<template>
    <div class="index group">
        <van-tabs @click="onClick" background="transparent" color="#245DC4">
            <van-tab title="看课系统"></van-tab>
            <van-tab title="直播系统"></van-tab>
        </van-tabs>
        <van-tabs
            v-model="live_status"
            @click="onClickStatus"
            background="transparent"
            type="card"
            color="#245DC4"
            style="margin-bottom: var(--base-px-10)"
        >
            <van-tab title="未开始"></van-tab>
            <van-tab title="进行中"></van-tab>
            <van-tab title="已结束"></van-tab>
        </van-tabs>
        <div class="list-container">
            <div class="list-container-left" v-if="live_channel_type == 2">
                <div
                    class="list-container-left-item"
                    :class="{
                        'list-container-left-item-active': classIndex == index,
                    }"
                    v-for="(item, index) in classList"
                    :key="index"
                    @click="getClass(index)"
                >
                    {{ item.train_name }}
                </div>
            </div>
            <div class="list-container-right">
                <List
                    v-model="loading"
                    :finished="finished"
                    :error="loadError"
                    :error-text="loadErrorText"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                    <div v-for="item in list" :key="item.id" class="list-item">
                        <div class="list-item-top">
                            <div class="list-item-left">
                                <img :src="item.cover" alt="" />
                            </div>
                            <div class="list-item-right">
                                <div class="list-item-right-title">
                                    {{ item.name }}
                                </div>
                                <div class="list-item-right-time">
                                    {{ item.tip }}
                                </div>
                            </div>
                        </div>
                        <div class="list-item-bottom">
                            <div class="list-item-right-time">
                                开始时间：{{ item.start_time }}
                            </div>
                            <div class="list-item-right-time">
                                结束时间：{{ item.end_time }}
                            </div>
                            <div class="list-item-right-btns">
                                <van-button
                                    v-if="
                                        live_status != 2 &&
                                        (live_channel_type == 2 ||
                                            live_channel_type == 1)
                                    "
                                    type="info"
                                    icon="share-o"
                                    size="mini"
                                    @click="createCourseSharingLink(item)"
                                    >分享</van-button
                                >
                                <!-- v-if="((live_status == 2 || live_status == 1)&&live_channel_type==2)||live_channel_type==1" -->
                                <van-button
                                    v-if="
                                        ((live_status == 2 ||
                                            live_status == 1) &&
                                            live_channel_type == 2) ||
                                        live_channel_type == 1
                                    "
                                    type="info"
                                    icon="todo-list-o"
                                    size="mini"
                                    @click="watchData(item)"
                                    >用户观看记录</van-button
                                >
                            </div>
                        </div>
                    </div>
                </List>
            </div>
        </div>
        <van-tabbar v-model="active" :safe-area-inset-bottom="true" class="tab">
            <van-tabbar-item replace to="/">
                <span>首页</span>
                <template #icon="props">
                    <img
                        v-if="props.active"
                        src="../../assets/images/home.png"
                    />
                    <img v-else src="../../assets/images/home-active.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/course/index" icon="search">
                <span>课程</span>
                <template #icon="props">
                    <img
                        v-if="props.active"
                        src="../../assets/images/course-active.png"
                    />
                    <img v-else src="../../assets/images/course.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/contact/index" icon="search">
                <span>客户</span>
                <template #icon="props">
                    <img
                        v-if="props.active"
                        src="../../assets/images/customer-active.png"
                    />
                    <img v-else src="../../assets/images/customer.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item
                replace
                :to="userDatalt.isDealer ? '/my' : '/my?id=' + userDatalt.id"
                icon="setting-o"
            >
                <span>{{ userDatalt.isDealer ? "我的" : "直播课" }}</span>
                <template #icon="props">
                    <img
                        v-if="props.active"
                        src="../../assets/images/my-active.png"
                    />
                    <img v-else src="../../assets/images/my.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item
                v-if="!userDatalt.isDealer && is_live"
                replace
                to="/live/index"
                icon="search"
            >
                <span>直播</span>
                <template #icon="props">
                    <img
                        v-if="props.active"
                        src="../../assets/images/live-active.png"
                    />
                    <img v-else src="../../assets/images/live.png" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <div v-show="showShare" @click="onShareClose()" class="share-bg"></div>
        <div v-show="showShare" class="share-content">
            <div class="w-full share-content-list">
                <div
                    class="share-content-item"
                    v-for="(item, index) in options"
                    :key="'share_' + index"
                    :id="'share' + index"
                    :data-clipboard-text="item.link_data.url"
                    @click="copy(item.link_data.url, 'share' + index)"
                >
                    <img
                        class="share-content-item-icon"
                        :src="item.image"
                        alt=""
                    />
                    <div class="share-content-item-name">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userCenter } from "@/api/homePage";
import {
    getLiveRoomGetQgList,
    liveRoomCreateCourseSharingLink,
    liveRoomGetHistoricalQgList,
    tenantLiveTrainList,
} from "@/api/live";
import { List } from "vant";
import Clipboard from "clipboard";
export default {
    components: {
        List,
    },
    data() {
        return {
            userDatalt: {
                isDealer: false,
                name: "",
                good: "",
            },
            active: 4,
            is_live: process.env.VUE_APP_IS_LIVE === "false" ? false : true,
            page: 0,
            loading: false,
            finished: false,
            loadError: false,
            loadErrorText: "",
            list: [],
            options: [],
            showShare: false,
            live_channel_type: 2,
            live_status: 0,
            classList: [
                {
                    train_name: "全部",
                    train_id: "",
                },
            ],
            classIndex: 0,
        };
    },
    created() {
        console.log(process.env);
        this.getTenantLiveTrainList();
    },
    methods: {
        getClass(index) {
            this.classIndex = index;
            this.list = [];
            this.page = 1;
            this.getLiveRoomGetQgList();
        },
        getTenantLiveTrainList() {
            tenantLiveTrainList().then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.classList = [
                        {
                            train_name: "全部",
                            train_id: "",
                        },
                        ...res.data,
                    ];
                }
            });
        },
        watchData(item) {
            if (this.live_channel_type == 2) {
                this.$router.push({
                    path: "/live/watchData",
                    query: {
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    path: "/live/watchDataLive",
                    query: {
                        id: item.id,
                    },
                });
            }
        },
        onClickStatus(index) {
            this.live_status = index;
            this.list = [];
            this.page = 1;
            this.getLiveRoomGetQgList();
        },
        onClick(index) {
            console.log(index);
            this.live_channel_type = index == 1 ? 1 : 2;
            this.list = [];
            this.page = 1;
            this.getLiveRoomGetQgList();
        },
        onLoad() {
            console.log("onLoad");
            this.page++;
            this.getLiveRoomGetQgList();
        },
        async getLiveRoomGetQgList() {
            let _this = this;
            this.loading = true;
            let resule = null;
            if (this.live_channel_type == 1) {
                resule = await getLiveRoomGetQgList({
                    page: this.page,
                    live_channel_type: this.live_channel_type,
                    status: Number(this.live_status) + 1,
                });
            } else {
                resule = await liveRoomGetHistoricalQgList({
                    live_status: this.live_status,
                    page: this.page,
                    limit: 10,
                    train_id: this.classList[this.classIndex].train_id,
                });
            }
            if (resule.code == 1) {
                _this.list = [...this.list, ...resule.data.list];
                if (resule.data.count <= _this.page * 10) {
                    _this.finished = true;
                } else {
                    _this.finished = false;
                }
                console.log("有数据", _this.list);
                this.$nextTick(() => {
                    _this.loading = false;
                    _this.loadError = false;
                    _this.loadErrorText = "";
                });
            } else {
                _this.loadError = true;
                _this.loadErrorText = resule.msg;
                this.$nextTick(() => {
                    _this.loading = false;
                });
            }
        },
        createCourseSharingLink(item) {
            liveRoomCreateCourseSharingLink({
                liveId: item.id,
                live_channel_type: this.live_channel_type,
            }).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.options = res.data;
                    this.showShare = true;
                }
            });
        },
        onShareClose() {
            this.showShare = false;
        },
        copy(url, id) {
            const that = this;
            this.text = url;
            let clipBoard = new Clipboard(`#${id}`);
            clipBoard.on("success", function () {
                clipBoard.destroy(); //销毁上一次的复制内容
                clipBoard = new Clipboard(`#${id}`);
                that.$toast.success("复制成功");
            });
            clipBoard.on("error", function () {
                that.$dialog.confirm({
                    title: "复制提示",
                    message: `链接生成失败，请重新点击获取`,
                    confirmButtonText: "我知道了",
                });
            });
        },
        userDetails() {
            const item = JSON.parse(localStorage.getItem("userDetails"));
            if (item) {
                this.userDatalt = item;
            }
            userCenter().then((res) => {
                this.userDatalt = res.data;
                this.userDatalt.isDealer = res.data.role == 1;
                this.is_examine = this.userDatalt.is_examine;
                const now = new Date();
                const hour = now.getHours();
                if (!item) {
                    localStorage.setItem(
                        "userDetails",
                        JSON.stringify(this.userDatalt)
                    );
                } else if (item.id !== this.userDatalt.id) {
                    localStorage.setItem(
                        "userDetails",
                        JSON.stringify(this.userDatalt)
                    );
                }
                if (hour < 6) {
                    this.userDatalt.good = "凌晨好";
                } else if (hour < 9) {
                    this.userDatalt.good = "早上好";
                } else if (hour < 12) {
                    this.userDatalt.good = "上午好";
                } else if (hour < 14) {
                    this.userDatalt.good = "中午好";
                } else if (hour < 17) {
                    this.userDatalt.good = "下午好";
                } else if (hour < 19) {
                    this.userDatalt.good = "傍晚好";
                } else if (hour < 22) {
                    this.userDatalt.good = "晚上好";
                } else {
                    this.userDatalt.good = "夜里好";
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.index {
    font-size: var(--base-px-14);
    height: 100%;
    background: #f2f3f7;
    overflow: auto;
}
.group {
    box-sizing: border-box;
    padding: var(--base-px-16) var(--base-px-12);
}
.list-item {
    padding: var(--base-px-10) var(--base-px-16);
    background: #fff;
    border-radius: var(--base-px-14);
    margin-bottom: var(--base-px-10);
}
.list-item-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.list-item-bottom {
    margin-top: var(--base-px-10);
}
.list-item-left {
    width: var(--base-px-80);
    height: var(--base-px-80);
    border-radius: var(--base-px-14);
    overflow: hidden;

    img {
        width: var(--base-px-80);
        height: var(--base-px-80);
        object-fit: cover;
    }
}

.list-item-right {
    flex: 1;
    height: 100%;
    margin-left: var(--base-px-10);
}

.list-item-right-title {
    font-size: var(--base-px-16);
    font-weight: bold;
    margin-bottom: var(--base-px-4);
}

.list-item-right-content {
    font-size: var(--base-px-14);
    color: #666;
}

.list-item-right-time {
    font-size: var(--base-px-12);
    color: #999;
}

.list-item-right-btns {
    margin-top: var(--base-px-10);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.share-bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}

.share-content {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 20%;
    background-color: #fff;
    border-radius: var(--base-px-16) var(--base-px-16) 0px 0px;
    overflow-y: auto;

    .share-content-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: var(--base-px-12);
    }

    .share-content-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .share-content-item-icon {
            width: var(--base-px-48);
            height: var(--base-px-48);
        }

        .share-content-item-name {
            font-size: var(--base-px-12);
            margin-top: var(--base-px-8);
            color: #646566;
        }
    }

    .share-content-item-icon {
        width: var(--base-px-48);
        height: var(--base-px-48);
    }

    .share-content-item-name {
        font-size: var(--base-px-12);
    }
}
.list-container {
    width: 100%;
    height: calc(100% - var(--base-px-100));
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.list-container-left {
    width: 80px;
    height: calc(100% - var(--base-px-30));
    overflow-y: scroll;
    background-color: #fff;
    margin-right: var(--base-px-10);
}
.list-container-left-item {
    padding: var(--base-px-10) var(--base-px-8);
    text-align: center;
}
.list-container-left-item-active {
    background-color: #1a89f9;
    color: #fff;
}
.list-container-right {
    flex: 1;
    height: 100%;
    overflow-y: scroll;
}
</style>
